import type { DealLinkProps } from '@uswitch/comms-ui.deal-link'
import classNames from 'classnames'
import React, { FC } from 'react'

import { DealLink } from '~/components/helpers/deal-link'
import { SegmentProps } from '~/interfaces/types'

import styles from './styles.module.css'

interface LinkProps {
  variant: 'button' | 'link'
  text: string
  isMobileView: boolean
  onClick?: () => void
}
interface BuyNowProps {
  text: string
  isMobileView: boolean
  dealLinkProps: DealLinkProps
  metadata?: {
    dimension94: string | undefined
    page: string
  }
  list?: string
  dealLinkRef?: React.RefObject<HTMLDivElement>
  criticalJs: boolean
  segmentProps?: SegmentProps
}

interface MoreInfoLinkProps {
  text: string
  isMobileView: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  onKeyUp?: (event: React.KeyboardEvent<HTMLAnchorElement>) => void
  href: string
}

export const Link: FC<LinkProps> = ({ variant, text, isMobileView, onClick = () => {} }) => (
  <div
    role={variant}
    className={styles.link}
    data-variant={variant}
    tabIndex={0}
    data-is-mobile-view={isMobileView}
    onClick={onClick}
    onKeyUp={onClick}
  >
    {text}
  </div>
)

export const BuyNowLink: FC<BuyNowProps> = ({
  dealLinkProps,
  metadata,
  list,
  text,
  isMobileView,
  dealLinkRef = null,
  criticalJs = false,
  segmentProps = { product: {}, promotion: {} }
}) => {
  if (criticalJs)
    return (
      <div
        className={classNames(styles.link, styles.buyNowLink, {
          [styles.isMobileView]: isMobileView
        })}
        data-variant='button'
        tabIndex={0}
        role='link'
      >
        <div className={styles.noClick} data-action='click->trigger#identity:stop'>
          <DealLink {...dealLinkProps}>
            <div
              className={styles.linkText}
              data-action='click->tracking#trackClickout click->tracking#trackSegment'
              data-tracking-properties-param={JSON.stringify({
                deal: dealLinkProps?.deal,
                list,
                position: dealLinkProps?.position,
                ecommerce: { comparisonId: dealLinkProps?.comparisonId, ...metadata },
                ...segmentProps.product
              })}
              data-tracking-event-param='Product Clicked'
            >
              {text}
            </div>
          </DealLink>
        </div>
      </div>
    )

  return (
    <div ref={dealLinkRef} className={styles.buyNowLink}>
      <DealLink {...dealLinkProps}>
        <div className={classNames(styles.link, styles.isMobileView)} data-variant='button' tabIndex={0} role='link'>
          {text}
        </div>
      </DealLink>
    </div>
  )
}

export const MoreInfoLink: FC<MoreInfoLinkProps> = ({ text, isMobileView, href, onClick, onKeyUp }) => (
  <a
    href={href}
    target='_blank'
    rel='noreferrer nofollow'
    className={classNames(styles.link, {
      [styles.isMobileView]: isMobileView
    })}
    data-variant='more-info'
    tabIndex={0}
    onKeyUp={onKeyUp}
    onClick={onClick}
  >
    {text}
  </a>
)
